import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import "../../../../styles/analytics/total-metrics.scss";
import CustomTooltip from "./custom-tooltip.jsx";

const TotalMetrics = ({ metricList, disableCompareData }) => {
  return (
    <Stack direction="row" flexWrap="wrap" className="metrics-container">
      {metricList.map((metric) => (
        <Stack
          direction="column"
          justifyContent="space-between"
          className={`metric-card ${metric.isSelected ? "selected" : ""}`}
          onClick={metric.onClick}
          key={`metric-${metric.label}`}
        >
          <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="left"
            flexWrap="wrap"
          >
            <Typography
              component="span"
              className="total-label"
              sx={{ marginBottom: "20px" }}
            >
              {metric.label}

              {metric.tooltip && (
                <CustomTooltip title={metric.tooltip}>
                  <span>
                    <i
                      className="fa fa-info-circle info-icon"
                      aria-hidden="true"
                    ></i>
                  </span>
                </CustomTooltip>
              )}
            </Typography>

            <Box
              sx={{
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                color: metric.negativeMetric
                  ? metric.percentage > 0 && !disableCompareData
                    ? "#DE0A26"
                    : "#16A34A"
                  : metric.percentage > 0 && !disableCompareData
                    ? "#16A34A"
                    : "#4B5563",
              }}
            >
              {disableCompareData ? (
                "N/A"
              ) : (
                <>
                  <i
                    className={`percent-icon fa ${
                      metric.percentage > 0
                        ? "fa-caret-up"
                        : metric.percentage === 0 ||
                          Number.isNaN(metric.percentage)
                        ? "fa-minus"
                        : "fa-caret-down"
                    } `}
                    aria-hidden="true"
                  ></i>
                  <Typography component="span" className="percentage-label">
                    {Number.isNaN(metric.percentage)
                      ? 0
                      : metric.percentage >= 0
                      ? metric.percentage
                      : -metric.percentage}
                    %
                  </Typography>
                </>
              )}
            </Box>
          </Stack>
          <Typography component="span" className="total-number">
            {Number.isNaN(metric.percentage)
              ? "N/A"
              : metric.total?.toLocaleString("en-US")}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default TotalMetrics;
